import { useQuery } from '@tanstack/react-query'
import { seriesKeys } from '@/api/queryKeys'
import { fetchSeriesById } from '@/api/series'

/**
 * Hook to fetch a single series by ID
 *
 * @param seriesId - Series ID (UUID)
 * @param includeRelations - Include related entities (moves, taggings)
 * @returns React Query result with series data
 *
 * @example
 * ```tsx
 * const { data: series, isLoading } = useSeriesDetail(seriesId, true);
 * ```
 */
export function useSeriesDetail(seriesId: string, includeRelations = true) {
  return useQuery({
    queryKey: [...seriesKeys.detail(seriesId), { includeRelations }] as const,
    queryFn: () => fetchSeriesById(seriesId, includeRelations),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!seriesId,
  })
}
